<!--<a href="/"><img src="../../assets/images/hageda-stumpf-logo.svg"  alt="Hageda-Stumpf Apothekenportal"/></a>-->
<router-outlet></router-outlet>
<app-footer [open]="true"></app-footer>
